module.exports = __webpack_public_path__ + "img/Samuel.498a278f.png";